import React from 'react';
import {emotionStyled} from '@packages/utilities/styled';

import {useDragItemContext} from './DragItemWrapper';
import {DragHandleIcon} from '../../icons';
import {Icon} from '../../icons/Icon';

import type {HTMLAttributes} from '../__SharedTypes';

export const DragItemHandleView = emotionStyled('div')(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    width: '$7',
    opacity: 0,
    zIndex: 1,
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
    '&:hover, &:focus': {
      opacity: 1,
    },
    '&:focus-visible': {
      outline: 'none',
      [`& ${Icon}`]: {
        outline: '$blueBorder',
        borderRadius: '$1',
      },
    },
  },
  {
    componentName: 'RowItemHoverView',
    variants: {
      isDragging: {
        true: {
          // We need a higher specificity than the :focus-within selector above.
          '&&&&': {
            opacity: 0,
          },
        },
      },
    },
  }
);

type RowItemHoverHandleProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Whether the RowItem should display a checkbox.
   * This will impact how large we want to make the DragHandle target area.
   */
  isCheckbox?: boolean;
};

/**
 * A handle that appears on the left side of a relative positioned element.
 */
export const DragItemHandle = React.forwardRef<
  HTMLDivElement,
  RowItemHoverHandleProps
>((props, ref) => {
  const {isDragging} = useDragItemContext();

  return (
    <DragItemHandleView {...props} isDragging={isDragging} ref={ref}>
      <DragHandleIcon style={{width: '5px'}} />
    </DragItemHandleView>
  );
});

DragItemHandle.displayName = 'DragItemHandle';
DragItemHandle.toString = DragItemHandleView.toString;
